<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="material">
      <div slot="toolbar">
        <el-button v-if="addAuth" type="primary" @click="$refs.editPage.open(0)">新建</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="查询">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="materialFinished" align="center" label="成品"/>
      <el-table-column prop="materialFinishedSemi" align="center" label="半成品"/>
      <el-table-column label="操作" align="center" class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button v-if="deleteAuth" type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <semi-finished-products-edit ref="editPage" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import SemiFinishedProductsEdit from "@/views/DeliveryManage/SemiFinishedProducts/SemiFinishedProductsEdit";
  export default {
    name: "SemiFinishedProductsList",
    components: {SemiFinishedProductsEdit,VmTable,VmSearch},
    data() {
      return {
        addAuth: this.$auth(54),
        deleteAuth: this.$auth(55),
        filter: {
          filter: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      deleteRow(row) {
        this.$http.delete("basic","material", row.pkid).then(() => {
          this.getList(-1);
          this.$message.success("删除成功");
        });
      },
    },
  };
</script>
<style scoped>
</style>
